import * as React from "react";
import { ExportToCsv } from "export-to-csv";
import { processData } from "./processing";

interface ICallbackOpts {
  target: string;
  type: string;
}

export const useExportTable = () => {
  const exportTableData = React.useRef<any>(null);
  const [disableExport, setDisableExport] = React.useState(true);
  const [fileNamePrefix, setFileNamePrefix] = React.useState("BRMExport_");
  const isReport = React.useRef<boolean>(false);

  const setExportTableData = React.useCallback(
    (value: any, report: boolean = false) => {
      exportTableData.current = value;
      isReport.current = report;
      if (
        exportTableData.current?.rawRows?.length ||
        exportTableData.current?.rows?.length ||
        (isReport.current && exportTableData.current?.originalName)
      ) {
        setDisableExport(false);
      } else {
        setDisableExport(true);
      }
    },
    [isReport]
  );

  const handleTableExport = React.useCallback(
    ({ type }: ICallbackOpts) => {
      const data = isReport.current ? exportTableData.current?.data : processData(exportTableData.current, type);
      const options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: false,
        filename: isReport.current
          ? `${fileNamePrefix}${exportTableData.current?.originalName}`
          : `${fileNamePrefix}${exportTableData.current?.originalName}_${type}`,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
      };
      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(data);
    },
    [exportTableData, fileNamePrefix, isReport]
  );

  return {
    disableExport,
    setExportTableData,
    handleTableExport,
    setFileNamePrefix,
  };
};
